/* Vivienne Westwood Original Site JS at 2024.9.3 */
// HTML内のインライン記述JSを主に移植

function closeWindow()
{
  //画面を閉じる
  window.close();
}

$(".js-accodion").on("click",function(){
  $(this).toggleClass("is-open");
  $(this).next().slideToggle();
});